import { render, staticRenderFns } from "./RegistroMFA.vue?vue&type=template&id=63dc2de6&scoped=true&"
import script from "./RegistroMFA.vue?vue&type=script&lang=js&"
export * from "./RegistroMFA.vue?vue&type=script&lang=js&"
import style0 from "./RegistroMFA.vue?vue&type=style&index=0&id=63dc2de6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dc2de6",
  null
  
)

export default component.exports